import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';


export class Alert extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Show: (this.props.Show || false)
        }
    }
   componentWillReceiveProps(nextProps){

       this.setState({Show:nextProps.Show})
   }
    render() {

        return (
            this.state.Show === true ?
                <SweetAlert
                    title={this.props.Title}
                    custom
                    customIcon="../../assets/images/pm-logo.svg"
                    onConfirm={() => this.setState({ Show: false })} >
                    {this.props.Description}
                </SweetAlert> : null
        )
    }
}
